// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SZBtR{background:none;border:0;cursor:pointer;font-family:inherit;font-weight:inherit;padding:0;-webkit-user-select:none;-moz-user-select:none;user-select:none}.SZBtR:active,.SZBtR:focus{outline:none}[aria-disable=true].SZBtR,[disabled].SZBtR{cursor:not-allowed;pointer-events:none}.gz47u{display:-webkit-box;display:flex;max-width:370px;-webkit-box-pack:end;justify-content:flex-end;-webkit-box-align:center;align-items:center}.gz47u,.nhIA5{font-size:15px}.nhIA5{color:#5d6466;font-weight:600;margin:0 0 10px}.zJZpn{color:#5d6466;line-height:1.57;margin:0}.SZBtR{color:inherit;text-decoration:underline}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"reloadButton": `SZBtR`,
	"root": `gz47u`,
	"title": `nhIA5`,
	"description": `zJZpn`
};
module.exports = ___CSS_LOADER_EXPORT___;
